var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_159)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.7726,
    y: 11.4993,
    width: 71.568,
    height: 71.568,
    rx: 35.784,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5524 23.5952L51.255 24.6519V55.3111L51.5524 55.6215L65.156 47.2092L51.5524 23.5952Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5524 23.5952L37.9484 47.2092L51.5524 55.6215V40.7403V23.5952Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5527 58.3159L51.3851 58.5297V69.451L51.5527 69.9628L65.1647 49.908L51.5527 58.3159Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5524 69.9628V58.3159L37.9484 49.908L51.5524 69.9628Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5527 55.6215L65.1564 47.2092L51.5527 40.7404V55.6215Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9484 47.2092L51.5524 55.6215V40.7404L37.9484 47.2092Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_159",
    x: 0.652582,
    y: 0.411267,
    width: 101.808,
    height: 101.808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.032
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.56
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_159",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_159"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.9484,
    y: 23.5952,
    width: 27.216,
    height: 46.368,
    rx: 13.608,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.18dd89e0cc8ef45f054fdbd38f97436e.svg";
export { ForwardRef as ReactComponent };